/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'health-score';
const componentName = 'avi-health-score-footer';
const prefix = `${moduleName}.${componentName}`;

export const viewHealthLabel = `${prefix}.viewHealthLabel`;

export const ENGLISH = {
    [viewHealthLabel]: 'View Health',
};
